import destaquesce from './destaques.png'
import horizontal_com_fotosce from './horizontal_com_fotos.png'
import horizontal_sem_fotoce from './horizontal_sem_foto.png'
import top_10_horizontalce from './top_10_horizontal.png'
import top_10_verticalce from './top_10_vertical.png'
import vertical_com_fotosce from './vertical_com_fotos.png'
import vertical_com_fotosc from './vertical_com_fotos_conteudos.jpg'
import top_10_verticalc from './top_10_vertical_conteudos.jpg'
import destaquesc from './destaques_conteudos.jpg'
import horizontal_sem_fotoc from './horizontal_sem_foto_conteudos.jpg'
import horizontal_com_fotosc from './horizontal_com_fotos_conteudos.jpg'

const templates = {
  cursoseeventos: {
    'DESTAQUES': destaquesce,
    'CARDS_VERTICAIS_COM_FOTO': vertical_com_fotosce,
    'CARDS_HORIZONTAIS_COM_FOTO': horizontal_com_fotosce,
    'CARDS_TOP_10_VERTICAIS': top_10_verticalce,
    'CARDS_TOP_10_HORIZONTAIS': top_10_horizontalce,
    'CARDS_HORIZONTAIS_SEM_FOTO': horizontal_sem_fotoce
  },
  conteudo: {
    'DESTAQUES': destaquesc,
    'CARDS_VERTICAIS_COM_FOTO': vertical_com_fotosc,
    'CARDS_HORIZONTAIS_COM_FOTO': horizontal_com_fotosc,
    'CARDS_TOP_10_VERTICAIS': top_10_verticalc,
    'CARDS_HORIZONTAIS_SEM_FOTO': horizontal_sem_fotoc
  }
}

export default templates